import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { GatewayAccountService } from '@tj/tj-dmp-lib-api';
import { MessageService } from 'primeng/api';
import { AccountService } from '../../admin/auth/account.service';

@Component({
    templateUrl: './account-reset-email.component.html',
    styleUrls: ['./account-reset-email.component.scss'],
    standalone: false
})
export class AccountResetEmailComponent {
	email: string;

	constructor(private gatewayAccountService: GatewayAccountService, private messageService: MessageService, private router: Router, private accountService: AccountService) {
	}

	ngOnInit() {
		this.accountService.identity().then((el) => {
			if(el) this.router.navigate(['/h']);
		})
	}

	save() {
		if(!this.email) {
			this.messageService.add({ severity: 'error', summary: 'Erreur', detail: "L'email n'a pas été saisi"})
			return;
		}
		this.gatewayAccountService.requestPasswordResetUsingPOST(this.email).subscribe(() => {
			this.messageService.add({ severity: 'success', summary: 'Succès', detail: "L'email a bien été envoyé, consultez votre boite mail"})
		}, () => {
			this.messageService.add({ severity: 'error', summary: 'Erreur', detail: "Une erreur s'est produite"})
		})
	}
}
